import * as React from 'react';
import { connect } from 'react-redux';
import store from '../store/store';
import types from '../store/types';
import { SummaryDialog } from '../components';
import { IOutputValue, EModalType, OutputsHelper, IOutputGroup, ComponentHelper } from '../helpers';

interface IProps {
    outputs: IOutputValue[];
    overId: string;
    fromId: string;
    overGroupIndex: number;
    fromGroupIndex: number;
    groups: IOutputGroup[];
    isSharedJourney: boolean;
}

class SummaryDialogContainer extends React.Component<IProps, any> {
    
    updateOutput = (output: IOutputValue): void => {
        store.dispatch({ type: types.UPDATE_SUMMARY_OUTPUT, output: output });
    }

	closeDialog = (save?: boolean) => {

        let { outputs, groups } = this.props;
        let reOrdered: IOutputValue[] = save
            ? OutputsHelper.UpdateOutputOrders(outputs, groups)
            : [];

        // Save the outputs
        if (save)
            OutputsHelper.SaveOutputs(reOrdered);
        
        store.dispatch({ type: types.TOGGLE_DIALOG, openModal: EModalType.None });

    }
    
    updateGroup = (groupName: string, outputId: string): void => {
        
        let { outputs } = this.props;
        let output: IOutputValue = outputs.filter(o => o.Id === outputId)[0];

        if (!output || output.Group === groupName)
            return;

        this.updateOutput({ ...output, Group: groupName });

    }

    updateShowOnSummary = (show: boolean, outputId: string): void => {
        
        let { outputs } = this.props;
        let output: IOutputValue = outputs.filter(o => o.Id === outputId)[0];

        if (!output || output.DisplayOnSummary === show)
            return;

        this.updateOutput({ ...output, DisplayOnSummary: show });
    }

    moveHandler = {
        drag: (e, id: string) => {
            store.dispatch({ type: types.SET_MOVE_FROM_SUMMARY, id: id });
        },
        drop: (e, toId: string) => {

            let { overId, fromId } = this.props;

            e.preventDefault();

            if (overId !== null && fromId !== null)
                store.dispatch({ type: types.MOVE_SUMMARY_OUTPUT, toId: toId });

        },
        allowDrop: (e, id: string) => {

            let { overId, fromId } = this.props;

            e.preventDefault();

            if (fromId !== null && id !== overId)
                store.dispatch({ type: types.SET_MOVE_OVER_SUMMARY, id: id });
        }
    };

    groupMoveHandler = {
        drag: (e, index: number) => {
            store.dispatch({ type: types.SET_MOVE_GROUP_FROM_SUMMARY, index: index });
        },
        drop: (e, toIndex: number) => {

            let { overGroupIndex, fromGroupIndex } = this.props;

            e.preventDefault();

            if (overGroupIndex !== null && fromGroupIndex !== null)
                store.dispatch({ type: types.MOVE_GROUP_SUMMARY_OUTPUT, toIndex: toIndex });

        },
        allowDrop: (e, i:number) => {

            let { overGroupIndex, fromGroupIndex } = this.props;

            e.preventDefault();

            if (fromGroupIndex !== null && i !== overGroupIndex)
                store.dispatch({ type: types.SET_MOVE_GROUP_OVER_SUMMARY, index: i });

        }
    };

	public render() {
		
		let { outputs, overId, groups, overGroupIndex, fromId, fromGroupIndex, isSharedJourney } = this.props;

		return <SummaryDialog outputs={ outputs }
            groups={ groups }
            closeDialog={ this.closeDialog }
            moveHandler={ this.moveHandler }
            groupMoveHandler={ this.groupMoveHandler }
            updateGroup={ this.updateGroup }
            updateShowOnSummary={ this.updateShowOnSummary }
            overId={ overId }
            overGroupIndex={ overGroupIndex }
            fromId={ fromId }
            fromGroupIndex={ fromGroupIndex }
            isSharedJourney={ isSharedJourney } />;
	}

}

const mapStateToProps = (store): IProps => {
    
    let { outputs, globalOutputs, groups } = store.modalState.summaryDialogState;

    outputs = outputs.map((outputValue: IOutputValue) => {
        outputValue.IsRepeatableBlockOutput = ComponentHelper.isRepeatableControlBlock(outputValue.componentId);
        return outputValue;
    });
    
    let combinedOutputs: IOutputValue[] = OutputsHelper.combineOutputs(outputs, globalOutputs, null);

    combinedOutputs = combinedOutputs.filter((value)=>!value.IsHidden);

    // Exclude "orphan" output references from groups.
    let cleanGroups: IOutputGroup[] = groups.map((g: IOutputGroup) => {
        return {
            name: g.name,
            outputs: g.outputs.filter(outputId => combinedOutputs.some(combinedOutput => combinedOutput.Id === outputId)),
            first: g.first
        }
    });

    return {
        outputs: combinedOutputs,
        overId: store.modalState.summaryDialogState.overId,
        fromId: store.modalState.summaryDialogState.fromId,
        overGroupIndex: store.modalState.summaryDialogState.overGroupIndex,        
        fromGroupIndex: store.modalState.summaryDialogState.fromGroupIndex,        
        groups: cleanGroups, 
        isSharedJourney: store.toolsState.isSharedJourney
    };

};

export default connect<any, any, any>(mapStateToProps)(SummaryDialogContainer);


// WEBPACK FOOTER //
// ./source/ts/containers/summary-dialog.tsx